<script lang="ts">
	import { getTranslate } from '@tolgee/svelte';

	export let value: string;

	const { t } = getTranslate();
</script>

<div class="flex-0 w-full md:w-2/5 relative">
	<input
		bind:value
		class="shadow-[none] focus:border-none focus:outline-none rounded-sm border-0 placeholder:text-accent-primary/35 bg-accent-primary_005 outline-none text-p-14 text-accent-primary !normal-case w-full pl-8 py-2"
		type="text"
		placeholder={$t('search.placeholder')}
	/>

	<div class="absolute left-2 inset-y-0 grid place-items-center">
		<button type="submit" aria-label="submit">
			<div
				class="i-sprenger-search h-5 cursor-pointer transition duration-500 text-accent-primary/35"
			/>
		</button>
	</div>
</div>
